<template>
    <little-bar
        :current="current"
        :navlist="navlist"
        @changeCurrent="changeCurrent"
       
    >
        <template v-slot:right-nav>
            <slot></slot>
        </template>
    </little-bar>
</template>
<script>
export default {
      data(){
        return{
            current: null,
			navlist: [
				 {
                    text: this.$t('lang.aboutFSP'),
                    // text: '未来科学大奖概述',
                    link: '/about/structure',
                },
                {
                    text: this.$t('lang.Bylaw'),
                    // text: '章程',
                    link: '/about/regulations',
                },
                {
                    text: this.$t('lang.Sciencecommittee'),
                    // text: '科学委员会',
                    link: '/about/science',
                },
                {
                    text:this.$t('lang.Supervisorycommittee'),
                    // text: '监督委员会',
                    link: '/about/oversight',
                },
                {
                    text:this.$t('lang.Contactus'),
                    // text: '联系我们',
                    link: '/about/contact',
                }
            ],
          
        }
    },
  
    created(){
       
    },
    mounted(){
        this.initCurrent()
    },
    methods:{
        initCurrent(){
             let arr = this.$route.path.split('/')
            switch(arr[arr.length-1]){
                case 'structure':
                    this.current = 0;
                    break;
                case 'regulations':
                    this.current = 1;
                    break;
                case 'science':
                    this.current = 2;
                    break;
                case 'oversight':
                    this.current = 3;
                    break;
                case 'contact':
                    this.current = 4;
                    break;
            }
        },
        changeCurrent(index, path){
            console.log(index)
            this.$router.push(path)
            this.current = index
        },
        
        
    }
}
</script>
<style lang="scss" scoped>

</style>